import React from 'react';
import SlideThumbnail from './SlideThumbnail';

function SlideThumbnailColumn(props) {

    //console.log("desktopMode = " + props.desktopMode);

    function imageThumbnails() {
        if (props.images == null) {
          return null;
        }
        return props.images.map((img, i) => (
          // Without the `key`, React will fire a key warning
          <SlideThumbnail
            key={"imtc_" + i}
            //fileName={props.urlBase + img.DSNomeFile}
            //title={img.DSMetaTitle_It}
            //alt={img.DSMetaDescrizione_It}
            fileName={img.url}
            title={img.alt}
            alt={img.alt}
            idx={i}
            active={props.currentIdx === i ? true : false}
            clickHandler={props.clickHandler}
          />
        ));    
    }  

    function videoThumbnails() {
      if (props.videos == null) {
        return null;
      }
      return props.videos.map((vid, i) => (
        // Without the `key`, React will fire a key warning
        <SlideThumbnail
          key={"vit_" + vid.ID_Video}
          fileName="/images/youtube_thumbnail.png"
          title=""
          alt={"vid_"+i}
          idx={props.images.length + i}
          active={props.currentIdx === (props.images.length + i) ? true : false}
          clickHandler={props.clickHandler}
        />
      ));    

    }

    return (
      <div className="contenitore-thumbnails">
        {props.arrows === true? <div className="AW-freccia-thumb-sx" onClick={props.prevSlide}>&nbsp;<img src={"/images/Arrow_up.svg"} alt="verso l'alto" /></div> : null}
 
        <div className="slide_thumbnails">
          <div className="slide_04">
          {imageThumbnails()}
          {videoThumbnails()}
          </div>
        </div>

        {props.arrows === true? <div className="AW-freccia-thumb-dx" onClick={props.nextSlide}>&nbsp;<img src={"/images/Arrow_down.svg" }  alt="verso il basso" /></div> : null}
      </div>
    );

}

export default SlideThumbnailColumn;